import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import RewriteRequestTable from "../../apiTables/RewriteRequestTable";

const RewriteRequestPage = ({hasClicked, setHasClicked}) => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar hasClicked={hasClicked} />
                    <RewriteRequestTable setHasClicked={setHasClicked}/>
                </div>
            </div>
        </div>
    );
};

export default RewriteRequestPage;
